import React, { useLayoutEffect, useReducer, useRef } from 'react';
import './Schedule.css';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import {faQuestionCircle, faThumbtack} from '@fortawesome/free-solid-svg-icons';
import LinearProgress from '@material-ui/core/LinearProgress';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem'
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton'

import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import Switch from '@material-ui/core/Switch';

import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import Clear from '@material-ui/icons/Clear';
import Grid from '@material-ui/core/Grid';
import LazyLoad from 'react-lazyload';

import { useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';


// import Menu from '@material-ui/core/Menu'; 
// import MenuItem from '@material-ui/core/MenuItem'; 
// import InputLabel from '@material-ui/core/InputLabel';
// import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 900,
    backgroundColor: theme.palette.background.paper,


  },
  accordion: {
    marginTop: 3,
    flexBasis:800, 
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  dropdown: {
    width: 200,
  },
  classContainer: {
    padding: 0,
  },
  pipeSeperator: {
    color: '#d8d8d8',
    marginLeft: 10,
    marginRight: 10,
    borderRight: '1px solid #d8d8d8'
  },
  greyedOut: {
    color: "#757575",
  },
  detailsPanel: {
    display: 'flex',
    flexDirection: 'column',
  },
  offCampus: {
    color: "#EB0000;",
    maxHeight: 18,
    position: 'relative',
    marginLeft: -3,
    top: 3,

  },
  info: {
    color: "#757575;",
    maxHeight: 18,
    position: 'relative',
    marginLeft: -3,
    top: 3,

  },
  question:{
   padding:'.5em',
    '&:hover': {
      color: "#009CC7"
    },
    '&:focus': {
      color: "#009CC7"
    }
  },
  formControl: {
    margin: 5,
    maxWidth: 200,
  },
  button: {
    margin: theme.spacing(2),
  },

  classArea: {
    marginTop: 20,
  },
  heading: {
    fontSize: 18,
  },
  menuItem: {
    whiteSpace: "unset",
    wordBreak: "break-all",
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
    height:15,
    color:'#fff',
    backgroundColor:'#005cab',
  }, 
  progress: {
    maxWidth: 800,
  }, 
  lazyLoad: {
    display:'flex', 
  }, 
  iconButton:{
    borderRadius:'0',
    maxHeight:50,
    marginTop:39,
    marginRight:10,
    marginLeft:10,
    transition: 'transform .2s',
    transform: 'rotate(30deg)',
    '&:focus': {
      transform: 'rotate(30deg)',
      color: "#009CC7 !important",
      background:"transparent !important",
      outline:"none !important"

      
    },
    '&:hover': {
      transform: 'rotate(0deg)',
      background:'none',
      color: "#009CC7"

    }

    
  },

  pinnedHeader:{
    alignItems:'flex-end',
  },

  snackBar:{

    backgroundColor:'#005cab',
    color:'#ffffff',

  },

  available:{
    marginTop: 20,
  },


  iconButtonOn:{
    borderRadius:'0',
    maxHeight:50,
    marginTop:39,
    marginRight:10,
    marginLeft:10,
    color:'#005cab',
    transition: 'transform .2s',
    transform: 'rotate(0deg)',
    
    '&:focus': {
      transform: 'rotate(0deg)',
      background:"transparent !important",
      outline:"none !important",
      color:'#009CC7 !important'
    
    },
    '&:active': {
      transform: 'rotate(30deg)',
      background:'none',
      color:'#009CC7'
    },

    '&:hover': {
      transform: 'rotate(0deg)',
      background:"transparent !important",
      outline:"none !important",
      color:'#009CC7 !important'
    }



    
  } 
   
}));

//#region StateMachine

const stateMachine = (state, action) => {

  switch (action.type) {
    case 'initSchedule':
      return { ...state, data: action.payload }

    case 'initSemesters':
      return { ...state, semesters: action.semesters }

    case 'initSubjects':
      return { ...state, subjects: action.payload }

    case 'initCourseTypes':
      return { ...state, courseTypes: action.payload }

    case 'initSessions':
      return { ...state, sessions: action.payload }

    case 'initLocations':
      return { ...state, locations: action.payload }

    case 'updateSubjects':
      return {...state, subjectsTags:action.tags, subjectsSelected:action.subjectsSelected }

    case 'updateCourseTypes':
      return {...state, courseTypesTags:action.tags, courseTypesSelected:action.courseTypesSelected}

    case 'updateSessions':
      return {...state, sessionsTags:action.tags, sessionsSelected:action.sessionsSelected}

    case 'updateLocations':
      return {...state, locationsTags:action.tags, locationsSelected:action.locationsSelected}

    case 'changeSemester':
      return { ...state, semsterOpen: action.open, semesterFilter: action.semesterText, semesterData: action.semesterData, courseTypesSelected: [], courseTypesTags:[], subjectsSelected: [], subjectsTags:[], sessionsSelected:[], sessionsTags:[], locationsSelected:[], locationsTags:[], searchText:'', termID:action.termID, programID:action.programID} 

    case 'updateLocation':
      return { ...state, locationTags:action.tags, locationsSelected:action.locationsSelected }

    case 'updateClasses':
      return {...state, displayedClasses:action.classes}

    case 'openSemester':
      return { ...state, semesterOpen: action.open }

    case 'search':
      return { ...state, searchText:action.searchVal }

    case 'clear':
      return { ...state, courseTypesSelected: [], courseTypesTags:[], subjectsSelected: [], subjectsTags:[], sessionsSelected:[], sessionsTags:[], locationsSelected:[], locationsTags:[], searchText:''}

    case 'expand':
      return { ...state, open: action.open, expand: action.expand }

    case 'pinClass':
      return {...state, pinnedClasses:action.classes}

    case 'snackBar':
      return {...state, openSnackBar:action.openSnackBar}

    default:
      return { ...state }
  }

}

//#endregion 


function Schedule() {

  const [state, dispatch] = useReducer(stateMachine, {
    data: [],
    semesterData: [],
    semesters: [],

    semesterFilter: '',
    termID:'',
    programID:'',
    semesterOpen: false,
    openExpand: false,
    expand: true,
    displayedClasses: [],
    searchedClasses: [],
    searchText: '',

    locations: [],
    locationsSelected:[],
    locationsTags:[],

    sessions: [],
    sessionsSelected:[],
    sessionsTags:[],

    courseTypes: [],
    courseTypesSelected:[],
    courseTypesTags:[],

    subjects: [],
    subjectsSelected:[],
    subjectsTags:[],

    pinnedClasses: [],
    

    openSnackBar: false,
  }
  )

  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);

  let searchT = React.useRef('');

  const dataRef = useRef(state.data);
  const semesterRef = useRef(state.semesterFilter); 


  const displayedClassesRef = useRef(state.displayedClasses); 
  const searchedClassesRef = useRef(state.searchedClasses);
  
  const subjectsSelectedRef = useRef(state.subjectsSelected); 
  const courseTypesSelectedRef = useRef(state.courseTypesSelected); 

  const sessionsSelectedRef = useRef(state.sessionsSelected);

  const subjectsTagsRef = useRef(state.subjectsTags); 
  const locationsTagsRef = useRef(state.locationsTags);
  const courseTypesTagsRef = useRef(state.courseTypesTags); 
  const sessionsTagsRef = useRef(state.sessionsTags); 
  const pinnedClassesRef = useRef(state.pinnedClasses);


  const [availableChecked, setAvailableChecked] = React.useState(false);
  const availableCheckedRef = useRef(availableChecked); 

  //#region Effects

  useLayoutEffect(() => {

    const fetchSchedule = async () => {
  
      try{

        const result = await axios({ 

          method:'get',  

          headers:{'Content-Type':'application/json',  

          'X-DreamFactory-Api-Key':'18604e220f1e023545f8ad5c5d1e67952a95d09a7063d5bb8640c75ac41d7889'},  

          crossDomain: true,  

          url:'https://dfprd.heartland.edu/api/v2/irdb_k2/_table/WEB_CLASS_SCHEDULE?order=COURSE_SORT%20ASC'  

        });   
    
         dispatch({type:'initSchedule', payload:result.data.resource}); 
  
      } catch(error){
        console.log(error); 
        const result = await axios.get('schedule.json'); 
        dispatch({type:'initSchedule', payload:result.data.resource}); 
      }

      

    };

    const fetchSubjects = async () => {
      try {
        const result = await axios({ 

          method:'get',  

          headers:{'Content-Type':'application/json',  

          'X-DreamFactory-Api-Key':'c7bbafa3068cc7485782a2f7ad4484ff3ca5320e126a87aad1522d390fac5cf5'},  

          crossDomain: true,  

          url:'https://dfprd.heartland.edu/api/v2/k2_smartboxdata/_table/IT_CreditSubjects?order=SUBJECT_LONG%20ASC'  

        }); 
        dispatch({ type: 'initSubjects', payload: result.data.resource });
      }
      catch (error) {
        console.log(error);
        const result = await axios.get('subjects.json');
        dispatch({ type: 'initSubjects', payload: result.data.resource });
      }


    };

    const fetchSemesters = async () => {

      try {
        const result = await axios.get('semesters.json');

        dispatch({ type: 'initSemesters', semesters: result.data.resource });

      } catch (error) {
        console.log(error);
        const result = await axios.get('semesters.json');
        dispatch({ type: 'initSemesters', semesters: result.data.resource });
      }


    };

    const fetchCourseTypes = async () => {

      try {
      const result = await axios.get('coursetype.json');
      dispatch({ type: 'initCourseTypes', payload: result.data.resource });
      }
      catch(error){
        console.log(error);
        const result = await axios.get('coursetype.json');
        dispatch({ type: 'initCourseTypes', payload: result.data.resource });
      }

    }

    const fetchSessions = async () => {
      try {
        const result = await axios.get('sessions.json');

        dispatch({ type: 'initSessions', payload: result.data.resource });
      }
      catch (error) {
        console.log(error);
        const result = await axios.get('sessions.json');
        dispatch({ type: 'initSessions', payload: result.data.resource });
      }


    };

    const fetchLocations = async () => {
      try {
        const result = await axios.get('locations.json');
        dispatch({ type: 'initLocations', payload: result.data.resource });
      }
      catch (error) {
        console.log(error);
        const result = await axios.get('locations.json');
        dispatch({ type: 'initLocations', payload: result.data.resource });

      }
    }
    
    const pinnedClasses = JSON.parse(localStorage.getItem('pinnedClasses'));

    if(pinnedClasses){
      dispatch({type:"pinClass", classes:pinnedClasses}); 
     
    }

    fetchSemesters();
    fetchSubjects();
    fetchCourseTypes();
    fetchLocations();
    fetchSessions();
    fetchSchedule();

  }, []);


  useEffect(() => {
    dataRef.current = state.data;
  }, [state.data]);

  useEffect(() => {
    semesterRef.current = state.semesterFilter;
     console.log(semesterRef.current);
  }, [state.semesterFilter]);

  useEffect(() => {

    displayedClassesRef.current = state.displayedClasses;
  }, [state.displayedClasses]);

  useEffect(() => {

    searchedClassesRef.current = state.searchedClasses;
    filterClasses( subjectsTagsRef.current, locationsTagsRef.current, courseTypesTagsRef.current, sessionsTagsRef.current, searchT.current, dataRef.current ); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchedClasses]);
  
  useEffect(() => {
    subjectsTagsRef.current = state.subjectsTags; 
        filterClasses( subjectsTagsRef.current, locationsTagsRef.current, courseTypesTagsRef.current, sessionsTagsRef.current, searchT.current, dataRef.current );  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.subjectsTags]);

  useEffect(() => {
    locationsTagsRef.current = state.locationsTags;
    filterClasses(  locationsTagsRef.current, subjectsTagsRef.current, courseTypesTagsRef.current, sessionsTagsRef.current, searchT.current, dataRef.current ); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.locationsTags] ); 

  useEffect(() => {
    courseTypesTagsRef.current = state.courseTypesTags;
    filterClasses(  courseTypesTagsRef.current , subjectsTagsRef.current, locationsTagsRef.current, sessionsTagsRef.current, searchT.current, dataRef.current ); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.courseTypesTags] );

  useEffect(() => {
    sessionsTagsRef.current = state.sessionsTags;
    filterClasses(  sessionsTagsRef.current, courseTypesTagsRef.current, subjectsTagsRef.current, locationsTagsRef.current, searchT.current, dataRef.current ); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.sessionsTags]);

  useEffect(() => {

    subjectsSelectedRef.current = state.subjectsSelected;

  }, [state.subjectsSelected]); 

  useEffect(() => {

    courseTypesSelectedRef.current = state.courseTypesSelected;

  }, [state.courseTypesSelected]);

  useEffect(() => {
    sessionsSelectedRef.current = state.sessionsSelected;
  }, [state.sessionsSelected]);


  useEffect(() => {

    searchT.current = state.searchText; 

    filterClasses(  sessionsTagsRef.current, courseTypesTagsRef.current, subjectsTagsRef.current, locationsTagsRef.current, searchT.current, dataRef.current ); 

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchText]);


  useEffect(() => {
    availableCheckedRef.current = availableChecked; 
    filterClasses(sessionsTagsRef.current, courseTypesTagsRef.current, subjectsTagsRef.current, locationsTagsRef.current, searchT.current, dataRef.current ); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableChecked]); 

  useEffect(() => {

    pinnedClassesRef.current = state.pinnedClasses;

    localStorage.setItem('pinnedClasses', JSON.stringify(state.pinnedClasses));

  }, [state.pinnedClasses] );
  

  function filterClasses (tag1, tag2, tag3, tag4, searchText, classes){
    
    classes = classes.filter(item => item.STRM === state.semesterFilter);

    classes = [...new Set(classes)];


    if(tag1.length){
      classes = classes.filter(course => Object.values(course).some(v => tag1.includes(v))); 
    }

    if(tag2.length){
      classes = classes.filter(course => Object.values(course).some(v => tag2.includes(v)));
    }

    if(tag3.length){
      classes = classes.filter(course => Object.values(course).some(v => tag3.includes(v)));
    }

    if(tag4.length){
      classes = classes.filter(course => Object.values(course).some(v => tag4.includes(v))); 
    }


    if(tag1.includes("Paired") || tag2.includes("Paired") || tag3.includes("Paired") || tag4.includes("Paired") ){


      classes.sort((a, b) => (a?.PAIRED_SORT ?? "").localeCompare(b?.PAIRED_SORT ?? "")); 
      
      
    }

   

    if(availableCheckedRef.current){
      console.log(availableCheckedRef.current);
      classes = classes.filter(item => item.ENRL_TOT < item.ENRL_CAP);
    }


  
    if(searchText !== '' && searchText !== null){
      
      searchText = searchText.toLowerCase();
      classes = classes.filter(item =>
        ((item.STRM + item.CLASS_LENGTH + item.CLASS_NBR + item.CLASS_FEE + item.SUBJECT + " " + item.CATALOG_NBR + " " + item.CLASS_SECTION + " " + item.SECTION_TYPE + " " + item.INSTRUCTION_MODE + " " + item.INSTRUCTION_MODE2 + " " + item.CLASS_TITLE + " " + item.Start_Time + " - " + item.End_Time + " " + item.CLASS_DAYS + " " + item.ENRL_CAP + " " + item.ROOM_CAP_REQUEST + " " + item.WAIT_CAP + " / " + item.WAIT_TOT + " " + item.WAIT_LIST_END_DT + item.ENRL_TOT + " " + item.Start_Date + " - " + item.End_Date + " " + item.LAST_NAME + " " + item.FIRST_NAME + " " + item.LOCATION + " " + item.FACILITY_ID + " " + item.CLASS_NOTE + " " + item.Credit_Hours + " " + item.Subject_Name).toLowerCase().includes(searchText)));
  
      classes.sort((a, b) => {
        let valA = '';
        let valB = ';'
        if (a.SUBJECT.toLowerCase().includes(searchText) || (a.SUBJECT.toLowerCase() + ' ' + a.CATALOG_NBR).includes(searchText) || a.CLASS_TITLE.toLowerCase().includes(searchText)) {
          valA = 0;
        } else {
          valA = 1;
        }
  
        if (b.SUBJECT.toLowerCase().includes(searchText) || (b.SUBJECT.toLowerCase() + ' ' + b.CATALOG_NBR).includes(searchText) || b.CLASS_TITLE.toLowerCase().includes(searchText)) {
          valB = 0;
        } else {
          valB = 1;
        }
        return valA - valB;
      }
  
      );
  
    }



    dispatch({type:'updateClasses', classes:classes}); 

}


  //#endregion

  //#region Handlers 

  const handleSemesterChange = event => {
    if (searchT.current.value) {
      searchT.current.value = "";
    }
    const semesterData = state.data.filter(item => item.STRM === event.target.value);
    const term = state.semesters.find(item => item.STRM === event.target.value);
    console.log(term);
   
    dispatch({ type: "clear", payload: semesterData});
    dispatch({ type: "changeSemester", open: !state.semesterOpen, semesterData: semesterData, displayedClasses: semesterData, semesterText: event.target.value, termID: term.Term_ID, programID: term.Program_ID });

  }

  const handleSemesterClose = () => {
    dispatch({ type: "openSemester", open: false });
  }

  const handleSemesterOpen = event => {
    dispatch({ type: "openSemester", open: true });
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSubject = event => {


    let tags = subjectsTagsRef.current;
    let diff = subjectsSelectedRef.current.filter(item => !event.target.value.includes(item)); 

    if(diff.length){
      tags = tags.filter(item => !item.includes(diff)); 
    }

    event.target.value.forEach(val => {tags.push(val)}); 

    let newTags = [...new Set(tags)]; 

    dispatch({type: 'updateSubjects', tags:newTags, subjectsSelected:event.target.value}); 

  }

  const handleCourseTypes = event => {

    let tags = courseTypesTagsRef.current; 
    let diff = courseTypesSelectedRef.current.filter(item => !event.target.value.includes(item));

    if(diff.length){
      tags = tags.filter(item => !item.includes(diff)); 
    }

    event.target.value.forEach(val => {tags.push(val)}); 

    let newTags = [...new Set(tags)]; 


    dispatch({type:'updateCourseTypes', tags:newTags, courseTypesSelected:event.target.value}); 

  }

  const handleSession = event => {

    let tags = sessionsTagsRef.current; 
    let diff = sessionsSelectedRef.current.filter(item => !event.target.value.includes(item));
    
    if(diff.length){
      tags = tags.filter(item => !item.includes(diff)); 
    }

   
    event.target.value.forEach(val => {
      tags.push(val);
   });

    let newTags = [...new Set(tags)]; 

    dispatch({type:'updateSessions', tags:newTags, sessionsSelected:event.target.value});

  }

  const handleLocations = event => {

    let tags = locationsTagsRef.current; 

    let diff = state.locationsSelected.filter(item => !event.target.value.includes(item)); 

    if(diff.length){
      tags = tags.filter(item => !item.includes(diff));
    }

    event.target.value.forEach(val => {
      tags.push(val);
   });

   let newTags = [...new Set(tags)]; 

   dispatch({type:'updateLocations', tags:newTags, locationsSelected:event.target.value});  

  }

  const handleClear = () => {
    if (searchT.current.value) {
      searchT.current.value = "";
    }
    
    setAvailableChecked(false);

    dispatch({ type: "clear", payload: state.data.filter(item => item.STRM === state.semesterFilter) });
  }

  const handleChangeAvailable = event => {

      setAvailableChecked((prev) => !prev); 

  }


  const handleSearch = event => {
    dispatch({type:"search", searchVal:event.target.value});

  }

  const handleOpenSnackBar = () => {

    dispatch({type:"snackBar", openSnackBar:!state.openSnackBar});

  }

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway'){
      return;
    }
    dispatch({type:'snackBar', openSnackBar:false});
  }

  const pinClass = (classItem) => {

    let classes = state.pinnedClasses; 

    if((!state.pinnedClasses.some(pc => classItem.SUBJECT + classItem.CATALOG_NBR + classItem.CLASS_SECTION + classItem.STRM + classItem.LAST_NAME + classItem.FIRST_NAME === pc.SUBJECT + pc.CATALOG_NBR + pc.CLASS_SECTION + pc.STRM + pc.LAST_NAME + pc.FIRST_NAME ))){
      classes = [...classes, classItem];
    } else {
      
     
     classes = classes.filter( (item,index) => 
        (item.SUBJECT + item.CATALOG_NBR + item.CLASS_SECTION + item.STRM + item.LAST_NAME + item.FIRST_NAME + index) !== (classItem.SUBJECT + classItem.CATALOG_NBR + classItem.CLASS_SECTION + classItem.STRM + classItem.LAST_NAME + classItem.FIRST_NAME + index)
      ); 

     
    }

    // console.log(classes);
    // classes = [...new Set(classes)];
    
     dispatch({type:'pinClass', classes:classes});
      
  }

  function transfer(type){

    switch(type){
  
      case 'CTE': 
        return <p><InfoIcon title="Note" className={classes.info} /><strong>Career and Technical Course</strong>: This course is a specific requirement for an Associate of Applied Science or certificate program and may not transfer. Please consult with your advisor about transferability.
        </p>
  
      case 'DEVED': 
        return <p><InfoIcon title="Note" className={classes.info} /><strong>Developmental Course</strong>: This course is not college level and will not transfer or count towards a degree or certificate program.</p>
      
      case 'GECC':
        return <p><InfoIcon title="Note" className={classes.info} />Transferrable General Education Course: This course generally should transfer to an Illinois Articulation Initiative college or university. Please consult with your advisor about transferability.</p>
      
      case 'TRNSFR': 
        return <p><InfoIcon title="Note" className={classes.info} />Transferrable Elective Course: This course generally should transfer to an Illinois Articulation Initiative college or university. Please consult with your advisor about transferability.</p>
  
      default: 
        break;
    }
   
  
  }

  const onDragEnd = result => {


    if(!result.destination) {return}; 

    if(
      (result.source.droppableId === result.destination.droppableId) &&
      (result.source.index === result.destination.index)
     ) {return};

     const newItems = [...pinnedClassesRef.current];      
     const draggedItem = newItems[result.source.index];

     newItems.splice(result.source.index, 1);
     newItems.splice(result.destination.index, 0, draggedItem);
     console.log(newItems);

     dispatch({type:"pinClass", classes:newItems});
     }

  //#endregion

  return (

    <div className={classes.classContainer}>
      
      <h2>Select a Semester</h2>
      { (state.data.length === 0) ?

        <div className={classes.progress} >
          <p>Getting class information...</p>
          <LinearProgress />

        </div>
        :

        <div>

          <FormControl className={classes.formControl}>
            <InputLabel id="semester-label">Semester</InputLabel>
            <Select
              className={classes.dropdown}
              labelId="semester-label"
              id="semester"
              open={state.semesterOpen}
              onClose={handleSemesterClose}
              onOpen={handleSemesterOpen}
              value={state.semesterFilter}
              onChange={handleSemesterChange}
              
            >

              {
                state.semesters.map((item, index) => (
                  <MenuItem key={index} value={item.STRM} name={item.Term} >{item.Term}</MenuItem>
                ))
              }

            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <Button className={classes.button}
              variant="outlined"
              color="primary"
              onClick={handleClear}
              startIcon={<Clear />}
            >
              Clear
      </Button></FormControl> 
        <FormControlLabel className={classes.available} label="Hide Filled Classes" control={<Switch checked={availableChecked} onChange={handleChangeAvailable} name="checkedAvailable" color="primary"  />}  />
        </div>}


      { (state.semesterFilter !== '') &&

        <div>
          <FormControl className={classes.formControl}>
            <Grid container alignItems="center">
              <Grid item><TextField  id="search" inputRef={searchT.current.value} label="Search" onChange={handleSearch} value={state.searchText} /></Grid>
              <Grid item><div style={{ position: 'absolute', top: '22px', right: '1px' }}> <SearchIcon aria-hidden='true' /> </div> </Grid>
            </Grid>
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel id="subject-label">Subject</InputLabel>
            <Select
              className={classes.dropdown}
              labelId="subject-label"
              id="subject"
              multiple
              value={state.subjectsSelected}
              onChange={handleSubject}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value, index) => (
                    <Chip key={index} label={value} className={classes.chip} />
                  ))}
                </div>
              )}
            >
              {
                state.subjects.map((item, index) => (
                  <MenuItem key={index} value={item.SUBJECT} >{item.SUBJECT_LONG}</MenuItem>
                ))
              }

            </Select>
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel id="course-type-label">Course Type</InputLabel>

            <Select className={classes.dropdown} 
            labelId="course-type-label" 
            id="course-type" 
            multiple
            value={state.courseTypesSelected}
            input={<Input />}
            onChange={handleCourseTypes}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value, index) => (
                  <Chip key={index} label={value} className={classes.chip} />
                ))}
              </div>
            )}
            >
            

              {
                state.courseTypes.map((item, index) => (
                  <MenuItem style={{ whiteSpace: 'pre-wrap' }} key={index} value={item.INSTRUCTION_MODE}>

                    {item.COURSE_TYPE + " " + item.DESCRIPTION}

                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel id="session-label">Session</InputLabel>

            <Select className={classes.dropdown} 
            labelId="session-label" 
            id="session" 
            value={state.sessionsSelected}
            multiple
            input={<Input />}
            onChange={handleSession}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {selected.map((value, index) => (
                  <Chip key={index} label={value} className={classes.chip} />
                ))}
              </div>
            )}
            >
    
              {
                state.sessions.map((item, index) => (

                  (state.semesterFilter.toString().includes('01')) ?

                    (item.SEMESTER === 'Summer') && <MenuItem key={index} value={item.CLASS_LENGTH}>{item.SESSION}</MenuItem> :

                    (item.SEMESTER === 'Spring / Fall') && <MenuItem key={index} value={item.CLASS_LENGTH}>{item.SESSION}</MenuItem>
                ))
              }

            </Select>
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel id="location-label">Campus Location</InputLabel>
            <Select
              className={classes.dropdown}
              labelId="location-label"
              id="location"
              multiple
              input={<Input />}
              value={state.locationsSelected}
              onChange={handleLocations}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value, index) => (
                    <Chip key={index} label={value} className={classes.chip} />
                  ))}
                </div>
              )}
            >
              {
                state.locations.map((item, index) => (

                  <MenuItem key={index} value={item.Value} name={item.Location} >{item.Location}</MenuItem>
                ))
              }

            </Select>
          </FormControl>

        

        </div>
      }

        {(state.pinnedClasses.length > 0) &&

        <div className={classes.classArea}>
          <Grid className={classes.pinnedHeader} container>
            <Grid item>
              <h3>Pinned Classes</h3> 
            </Grid>
            <Grid item>
              <IconButton size="small" className={classes.question} aria-label="Pin to Top" color="default" onClick={handleOpenSnackBar} >
                <FontAwesomeIcon icon={faQuestionCircle}/>
              </IconButton>
            </Grid>
          </Grid>
          
          <DragDropContext onDragEnd={onDragEnd}  >
            <Droppable droppableId="droppable">
              { provided => (
              <div {...provided.droppableProps} ref={provided.innerRef} >
                
          {(state.pinnedClasses).map((item, index) => {
            const ident = item.SUBJECT + item.CATALOG_NBR + item.CLASS_SECTION + item.STRM + item.LAST_NAME + item.FIRST_NAME + index;
            const time = (item.FACILITY_ID === "ONLINE" || item.FACILITY_ID === "HCC FLEX") ? "" : item.CLASS_DAYS + " " + item.Start_Time + " - " + item.End_Time + "    |    ";
            const location = (item.FACILITY_ID === "ONLINE" || item.FACILITY_ID === "HCC FLEX") ? "" : item.FACILITY_ID + " | ";
            const available = item.ROOM_CAP_REQUEST - item.ENRL_TOT;
            const isClosed = item.ENRL_CAP - item.ENRL_TOT;
            const pairedAvailable = item.PAIRED_CAP_REQUEST - item.PAIRED_ENRL_TOT;
            const now = moment();

            return    <Draggable key={index + "draggable"} draggableId={index + "draggable"} index={index} >
              { provided => (
              
              <div  className={classes.pinnedClassContainer} ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}>
                 
              <LazyLoad key={index + "lazy"} height={50} className={classes.lazyLoad}> 
              
              <Accordion expanded={expanded === ident} key={ident} onChange={handleChange(ident)} className={classes.accordion} >
     
              <AccordionSummary expandIcon={<ExpandMoreIcon />}  aria-controls={    ident.replace(/ /g, '') } id={    ident.replace(/ /g, '') }>
                <div className={classes.heading}>
                  <Typography variant="h3" className={classes.heading}>{item.SUBJECT + " " + item.CATALOG_NBR + " " + item.CLASS_SECTION + " " + item.CLASS_TITLE} </Typography>


                  <Typography className={classes.secondaryHeading}>{time} {(item.LOCATION === "PONTIAC" || item.LOCATION === "LINCOLN") ?
                    <span ><InfoIcon className={classes.offCampus} />{location}</span> : <span>{location}</span>
                  }{item.INSTRUCTION_MODE2 + " " + item.SECTION_TYPE}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>Dates: {" " + item.Start_Date + "-" + item.End_Date + " " + item.CLASS_LENGTH}</Typography>

                  <Typography className={classes.secondaryHeading}>Instructor: {item.FIRST_NAME + " " + item.LAST_NAME} | Credit Hours: {item.Credit_Hours} {(item.CLASS_NBR) && " | Course Code:" + item.CLASS_NBR}</Typography>

                  {(isClosed > 0) && (item.PAIRED_FLAG) && <Typography className={classes.secondaryHeading}>Paired Seats Available: {" " + pairedAvailable + " / " + item.PAIRED_CAP_REQUEST}</Typography>}

                  {((item.WAIT_CAP > 0) && (item.ENRL_TOT >= item.ENRL_CAP)) ?


                    ((moment(now, "MM-DD-YYYY").isSameOrAfter(moment(item.WAIT_LIST_END_DT, "MM-DD-YYYY"))) ?
                      <Typography className={classes.greyedOut}><strong>Waitlist Closed</strong></Typography> :
                      <Typography className={classes.secondaryHeading}>Waitlist: {" " + item.WAIT_TOT + " / " + item.WAIT_CAP}</Typography>) :


                    (isClosed > 0) ?

                      <Typography className={classes.secondaryHeading}>Available Seats: {" " + available + " / " + item.ROOM_CAP_REQUEST}</Typography> :
                      (item.ENRL_CAP !== 0) ?
                        <Typography className={classes.greyedOut}><strong>Class Full</strong></Typography> :
                        <Typography className={classes.greyedOut}><strong>Registration Closed</strong></Typography>
                  }
                </div>
              </AccordionSummary>
              <AccordionDetails className="details">
                {(expanded === ident) &&
                  <div>
                    <Typography className={classes.secondaryHeading}>{item.CATALOG_DESCR}</Typography>
                    <Typography className={classes.secondaryHeading}>{item.PREREQUISITE}</Typography>
                    <Typography className={classes.secondaryHeading}><a href={"https://www.bkstr.com/webApp/discoverView?bookstore_id-1=633&term_id-1=" + state.termID + "&dept-1=" + item.SUBJECT + "&course-1=" + item.CATALOG_NBR + "&section-1=" + item.CLASS_SECTION  } target="_blank" rel="noopener noreferrer" className={"textbookLink"}>Textbooks</a></Typography>

                 
                    {(item.CLASS_FEE) && <Typography className={classes.secondaryHeading}>Fees: {" $" + item.CLASS_FEE}</Typography>}
                    {(item.CLASS_NOTE) &&
                      <div>
                        {(item.LOCATION === "PONTIAC" || item.LOCATION === "LINCOLN") ?
                          <Typography><InfoIcon title="Note" className={classes.offCampus} /> {" " + item.CLASS_NOTE}</Typography> :
                          <Typography><InfoIcon title="Note" className={classes.info} /> {" " + item.CLASS_NOTE}</Typography>
                        }
                      </div>
                    }
                       {transfer(item.TRANSFER_TYPE)}
                  
                  </div>}</AccordionDetails>
            </Accordion> 
            
            {
            (state.pinnedClasses.includes(item)) ?
            <IconButton
            aria-label="Pin to Top" 
            color="secondary"
            className={classes.iconButtonOn}
            onClick={() => pinClass(item)}
            >
              <FontAwesomeIcon icon={faThumbtack}/>
              </IconButton> :

            <IconButton
            aria-label="Pin to Top" 
            color="default"
            className={classes.iconButton}
            onClick={() => pinClass(item)}
            >
              <FontAwesomeIcon icon={faThumbtack}/>
              </IconButton> 

              }
              
            </LazyLoad> 
            </div>
              )}
            </Draggable>
          })}
           {provided.placeholder}
          </div>
          )}
          </Droppable>
         </DragDropContext> 
        <h3>All Classes</h3>
        </div>

        }


      {(state.displayedClasses) &&

        <div className={classes.classArea}>

      
          {(state.displayedClasses).map((item, index) => {
            const ident = item.SUBJECT + item.CATALOG_NBR + item.CLASS_SECTION + item.STRM + item.LAST_NAME + item.FIRST_NAME + index;
        
            const time = (item.FACILITY_ID === "ONLINE" || item.FACILITY_ID === "HCC FLEX") ? "" : item.CLASS_DAYS + " " + item.Start_Time + " - " + item.End_Time + "    |    ";
            const location = (item.FACILITY_ID === "ONLINE" || item.FACILITY_ID === "HCC FLEX") ? "" : item.FACILITY_ID + " | ";
            const available = item.ROOM_CAP_REQUEST - item.ENRL_TOT;
            const isClosed = item.ENRL_CAP - item.ENRL_TOT;
            const pairedAvailable = item.PAIRED_CAP_REQUEST - item.PAIRED_ENRL_TOT;
            const now = moment();
           

            return <LazyLoad once key={index + "lazy"} height={10} className={classes.lazyLoad}> <Accordion expanded={expanded === ident} key={ident} onChange={handleChange(ident)} className={classes.accordion} >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}  aria-controls={ ident.replace(/ /g, '') } id={    ident.replace(/ /g, '') }>
                <div className={classes.heading}>
                  <Typography variant="h3" className={classes.heading}>{item.SUBJECT + " " + item.CATALOG_NBR + " " + item.CLASS_SECTION + " " + item.CLASS_TITLE} </Typography>


                  <Typography className={classes.secondaryHeading}>{time} {(item.LOCATION === "PONTIAC" || item.LOCATION === "LINCOLN") ? <span ><InfoIcon className={classes.offCampus} />{location}</span> : <span>{location}</span>
                  }{  (item.INSTRUCTION_MODE2 === "Online-Additional Requirements") ?  <span> <InfoIcon className={classes.offCampus} /> {item.INSTRUCTION_MODE2 + " " + item.SECTION_TYPE} </span> : item.INSTRUCTION_MODE2 + " " + item.SECTION_TYPE }
                  </Typography>
                  <Typography className={classes.secondaryHeading}>Dates: {" " + item.Start_Date + "-" + item.End_Date + " " + item.CLASS_LENGTH}</Typography>

                  <Typography className={classes.secondaryHeading}>Instructor: {item.FIRST_NAME + " " + item.LAST_NAME} | Credit Hours: {item.Credit_Hours}  {(item.CLASS_NBR) && " | Course Code:" + item.CLASS_NBR} </Typography>

                  {(isClosed > 0) && (item.PAIRED_FLAG) && <Typography className={classes.secondaryHeading}>Paired Seats Available: {" " + pairedAvailable + " / " + item.PAIRED_CAP_REQUEST}</Typography>}

                  {((item.WAIT_CAP > 0) && (item.ENRL_TOT >= item.ENRL_CAP)) ?


                    ((moment(now, "MM-DD-YYYY").isSameOrAfter(moment(item.WAIT_LIST_END_DT, "MM-DD-YYYY"))) ?
                      <Typography className={classes.greyedOut}><strong>Waitlist Closed</strong></Typography> :
                      <Typography className={classes.secondaryHeading}>Waitlist: {" " + item.WAIT_TOT + " / " + item.WAIT_CAP}</Typography>) :




                    (isClosed > 0) ?

                      <Typography className={classes.secondaryHeading}>Available Seats: {" " + available + " / " + item.ROOM_CAP_REQUEST}</Typography> :
                      (item.ENRL_CAP !== 0) ?
                        <Typography className={classes.greyedOut}><strong>Class Full</strong></Typography> :
                        <Typography className={classes.greyedOut}><strong>Registration Closed</strong></Typography>
                  }
                </div>
              </AccordionSummary>
              <AccordionDetails className="details">
                {(expanded === ident) &&
                  <div>
                    <Typography className={classes.secondaryHeading}>{item.CATALOG_DESCR}</Typography>
                    <Typography className={classes.secondaryHeading}>{item.PREREQUISITE}</Typography>
                    <Typography className={classes.secondaryHeading}><a href={"https://www.bkstr.com/webApp/discoverView?bookstore_id-1=633&term_id-1=" + state.termID + "&dept-1=" + item.SUBJECT + "&course-1=" + item.CATALOG_NBR + "&section-1=" + item.CLASS_SECTION  }  target="_blank" rel="noopener noreferrer" className={"textbookLink"}>Textbooks</a></Typography>

              
                    {(item.CLASS_FEE) && <Typography className={classes.secondaryHeading}>Fees: {" $" + item.CLASS_FEE}</Typography>}
                    {(item.CLASS_NOTE) &&
                      <div>
                        {(item.LOCATION === "PONTIAC" || item.LOCATION === "LINCOLN") ?
                          <Typography><InfoIcon title="Note" className={classes.offCampus} /> {" " + item.CLASS_NOTE}</Typography> :
                          <Typography><InfoIcon title="Note" className={classes.info} /> {" " + item.CLASS_NOTE}</Typography>
                        }
                      </div>
                    }
                    {transfer(item.TRANSFER_TYPE)}


  
                   
                  </div>}</AccordionDetails>
            </Accordion> 
            
            {
            (state.pinnedClasses.some(pc => item.SUBJECT + item.CATALOG_NBR + item.CLASS_SECTION + item.STRM + item.LAST_NAME + item.FIRST_NAME === pc.SUBJECT + pc.CATALOG_NBR + pc.CLASS_SECTION + pc.STRM + pc.LAST_NAME + pc.FIRST_NAME )) ?
            <IconButton
            aria-label="Pin to Top" 
            color="secondary"
            className={classes.iconButtonOn}
            onClick={() => pinClass(item)}
            >
              <FontAwesomeIcon icon={faThumbtack}/>
              </IconButton> :

            <IconButton
            aria-label="Pin to Top" 
            color="default"
            className={classes.iconButton}
            onClick={() => pinClass(item)}
            >
              <FontAwesomeIcon icon={faThumbtack}/>
              </IconButton> 

              }
            </LazyLoad>
          })}

        </div>

      }



      <Snackbar  anchorOrigin={{vertical:'bottom', horizontal:'center'}} message="Pinned items will stay pinned until you clear your browser settings. You can organize your pinned items by dragging and dropping!" open={state.openSnackBar}  action={<IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
              <CloseIcon fontSize="small" />
            </IconButton>} />


    </div>

  );
}

export default Schedule;

